import React from "react";
import p1 from '../../../assets/Images/career/c_2.JPG'
import p2 from '../../../assets/Images/career/c_3.JPG'
import p3 from '../../../assets/Images/career/c_4.JPG'
const Third_CareerSection = () => {
  const data = [
    {
      title: "",
      img: p1,
    },
    {
      title: "",
      img: p2,
    },
    {
      title: "",
      img: p3,
    },
  ];

  return (
    <section className="bg-[#F2F6EF] py-12 md:py-16">

      {/* INLINE CSS */}
      <style>{`
          .gradient-text {
          background: linear-gradient(135deg, #355931 0%, #A4BE2C 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

          `}</style>
          
      <div className="max-w-7xl mx-auto px-4 sm:px-6 text-center">

          {/* Main Heading */}
          <h2 className="text-3xl sm:text-4xl md:text-5xl text-center lg:text-4xl font-serif text-[#355931] leading-tight">
           Experience the <span className="gradient-text">  Nutralike Difference </span>
           
          </h2>
             {/* Underline */}
            <div
              className="
                w-24
                h-[2px]
                mx-auto
                mt-6
                mb-6
                dw-fade-up
              "
              style={{
                animationDelay: "240ms",
                background:
                  "linear-gradient(90deg, transparent 0%, #355931 30%, #A4BE2C 70%, transparent 100%)",
              }}
            />

        {/* Cards - Responsive Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {data.map((item, index) => (
            <div key={index} className="group">
              
              {/* Image Container */}
              <div className="overflow-hidden rounded-xl">
               <div className="shine">
                 <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-[200px] sm:h-[220px] md:h-[240px] lg:h-[300px] object-cover rounded-xl transition-transform duration-500 group-hover:scale-105"
                />
               </div>
              </div>

              {/* Title */}
              <h3 className="mt-3 sm:mt-4 text-sm sm:text-base md:text-lg font-semibold text-[#2f4f2f] tracking-wide">
                {item.title}
              </h3>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Third_CareerSection;